export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.20-1156.20",
  commitId: "941023402cf1afc703062c919c0e3c9fee937ba0",
  commitTime: "2026-07-20T11:56:20.000Z",
});
